module.exports = __webpack_public_path__ + "img/art-gallery.bae06cd5.svg";